/* global fetch */
(function () {
  'use strict';
  const routes = window.routes || {};
  const root = window.Shopify?.routes?.root || '/';
  window.shopCurrency = document.documentElement.getAttribute('data-currency') || 'EUR';
  const money = (cents) => (Number(cents || 0) / 100).toLocaleString(undefined, { style: 'currency', currency: window.shopCurrency });
  const safeURL = (value, sameOrigin = false) => {
    if (!value) return null;
    try {
      const url = new URL(String(value), window.location.origin);
      if (!['https:', 'http:'].includes(url.protocol) || (sameOrigin && url.origin !== window.location.origin)) return null;
      return url;
    } catch (_) { return null; }
  };
  const route = (key, fallback) => {
    const url = safeURL(routes[key] || root + fallback, true);
    return url ? url.pathname + url.search : root + fallback;
  };
  const jsonRoute = (key, fallback) => {
    const url = new URL(route(key, fallback), window.location.origin);
    if (!url.pathname.endsWith('.js')) url.pathname += '.js';
    return url.pathname + url.search;
  };
  const cartURL = route('cart_url', 'cart');
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  async function requestJSON(url, options = {}) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
      const payload = await response.json().catch(() => null);
      if (!response.ok || !payload) {
        const error = new Error(payload?.description || payload?.message || 'We could not update your basket. Please try again.');
        error.status = response.status;
        throw error;
      }
      return payload;
    } catch (error) {
      if (error.name === 'AbortError') throw new Error('The basket request timed out. Check your basket before adding again.');
      throw error;
    } finally { window.clearTimeout(timeout); }
  }

  /* One modal at a time: focus, background interaction and scroll return together. */
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerOverlay = document.querySelector('[data-drawer-overlay]');
  const mnav = document.querySelector('[data-mobile-nav]');
  const mnavOverlay = document.querySelector('[data-mobile-nav-overlay]');
  let activeModal = null;
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function focusables(panel) {
    return Array.from(panel.querySelectorAll(focusableSelector)).filter((node) => !node.disabled && !node.closest('[hidden], [inert]') && node.getClientRects().length);
  }
  function focusFirst(panel) { (focusables(panel)[0] || panel).focus({ preventScroll: true }); }
  function closeModal(restoreFocus = true) {
    if (!activeModal) return;
    const current = activeModal;
    activeModal = null;
    current.panel.classList.remove('is-open');
    current.panel.setAttribute('aria-hidden', 'true');
    current.panel.inert = true;
    current.overlay?.classList.remove('is-open');
    current.triggers.forEach((node) => node.setAttribute('aria-expanded', 'false'));
    current.background.forEach(([node, wasInert]) => { node.inert = wasInert; });
    document.body.style.overflow = current.overflow;
    document.body.style.paddingRight = current.paddingRight;
    if (restoreFocus) {
      const target = current.trigger?.isConnected && !current.trigger.disabled ? current.trigger : current.triggers[0];
      target?.focus({ preventScroll: true });
    }
  }
  function openModal(panel, overlay, trigger, triggerSelector) {
    if (!panel) return false;
    if (activeModal?.panel === panel) return true;
    closeModal(false);
    const background = [];
    let branch = panel;
    while (branch.parentElement && branch !== document.body) {
      Array.from(branch.parentElement.children).forEach((sibling) => {
        if (sibling !== branch && sibling !== overlay && !['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) {
          background.push([sibling, sibling.inert]);
          sibling.inert = true;
        }
      });
      branch = branch.parentElement;
    }
    const overflow = document.body.style.overflow;
    const paddingRight = document.body.style.paddingRight;
    const scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    if (scrollbar) document.body.style.paddingRight = (parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar) + 'px';
    document.body.style.overflow = 'hidden';
    const triggers = Array.from(document.querySelectorAll(triggerSelector));
    activeModal = { panel, overlay, trigger: trigger || document.activeElement, triggers, background, overflow, paddingRight };
    panel.hidden = false;
    panel.inert = false;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panel.setAttribute('tabindex', '-1');
    panel.classList.add('is-open');
    overlay?.classList.add('is-open');
    triggers.forEach((node) => node.setAttribute('aria-expanded', 'true'));
    focusFirst(panel);
    return true;
  }
  [[drawer, '[data-open-cart]', 'buyaphone-cart-drawer'], [mnav, '[data-open-nav]', 'buyaphone-mobile-nav']].forEach(([panel, selector, id]) => {
    if (!panel) return;
    panel.id = panel.id || id;
    panel.inert = true;
    panel.setAttribute('aria-hidden', 'true');
    document.querySelectorAll(selector).forEach((trigger) => {
      trigger.setAttribute('aria-controls', panel.id);
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-haspopup', 'dialog');
    });
  });
  function announceCart(message, error = false) {
    if (!drawer) return;
    let status = drawer.querySelector('[data-cart-status]');
    if (!status) {
      status = element('p', 'cart-status');
      status.dataset.cartStatus = '';
      status.setAttribute('aria-live', 'polite');
      status.style.padding = '0 24px';
      drawer.querySelector('.drawer__header')?.after(status);
      if (!status.isConnected) drawer.prepend(status);
    }
    status.setAttribute('role', error ? 'alert' : 'status');
    status.textContent = message;
    status.hidden = !message;
  }
  function openDrawer(trigger) {
    if (!openModal(drawer, drawerOverlay, trigger, '[data-open-cart]')) { window.location.assign(cartURL); return; }
    Cart.refresh().catch(() => announceCart('Your basket could not be refreshed. Use View basket below to check your items.', true));
  }
  window.openCartDrawer = openDrawer;
  document.addEventListener('keydown', (event) => {
    if (!activeModal || event.defaultPrevented) return;
    if (event.key === 'Escape') { event.preventDefault(); closeModal(); }
    else if (event.key === 'Tab') {
      const nodes = focusables(activeModal.panel);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (!first) { event.preventDefault(); activeModal.panel.focus(); }
      else if (event.shiftKey && (document.activeElement === first || !activeModal.panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !activeModal.panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('focusin', (event) => { if (activeModal && !activeModal.panel.contains(event.target)) focusFirst(activeModal.panel); });

  /* Cart API: serialised writes avoid stale line-number/quantity races. */
  let cartQueue = Promise.resolve();
  const enqueue = (operation) => {
    const next = cartQueue.catch(() => {}).then(operation);
    cartQueue = next;
    return next;
  };
  let cartReadSequence = 0;
  const Cart = {
    add(id, quantity = 1) {
      if (!/^\d+$/.test(String(id || '')) || !Number.isInteger(quantity) || quantity < 1) return Promise.reject(new Error('Choose an available option and a valid quantity.'));
      return enqueue(async () => {
        ++cartReadSequence;
        const added = await requestJSON(jsonRoute('cart_add_url', 'cart/add'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: String(id), quantity }] })
        });
        // Addition has succeeded. A refresh failure must not encourage a duplicate addition.
        await this.refresh().catch(() => announceCart('Item added. View your basket to confirm the latest total.', true));
        return added;
      });
    },
    change(lineOrKey, quantity) {
      if (!Number.isInteger(quantity) || quantity < 0) return Promise.reject(new Error('Choose a valid quantity.'));
      return enqueue(async () => {
        ++cartReadSequence;
        const identifier = typeof lineOrKey === 'string' ? { id: lineOrKey } : { line: lineOrKey };
        const cart = await requestJSON(jsonRoute('cart_change_url', 'cart/change'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...identifier, quantity })
        });
        this.render(cart); this.updateCount(cart.item_count);
        return cart;
      });
    },
    get() { return requestJSON(jsonRoute('cart_url', 'cart')); },
    async refresh() {
      const sequence = ++cartReadSequence;
      const cart = await this.get();
      if (sequence === cartReadSequence) { this.updateCount(cart.item_count); this.render(cart); }
      return cart;
    },
    updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = String(Number(count) || 0); node.hidden = !count; });
    },
    render(cart) {
      const body = drawer?.querySelector('[data-drawer-items]');
      if (!body || !Array.isArray(cart.items)) return;
      const focused = body.contains(document.activeElement) ? document.activeElement : null;
      const focusedKey = focused?.closest('[data-cart-key]')?.dataset.cartKey;
      const focusedControl = focused?.hasAttribute('data-qty-up') ? 'data-qty-up' : focused?.hasAttribute('data-qty-down') ? 'data-qty-down' : 'data-remove';
      const fragment = document.createDocumentFragment();
      if (!cart.items.length) fragment.append(element('p', 'text-center muted', 'Your basket is empty.'));
      cart.items.forEach((item, index) => {
        const row = element('div', 'cart-item');
        row.dataset.line = String(index + 1); row.dataset.cartKey = item.key || String(item.variant_id || item.id);
        const media = element('div', 'cart-item__media');
        const imageURL = item.image && safeURL(item.image);
        if (imageURL) {
          imageURL.searchParams.set('width', '180');
          const image = element('img');
          image.src = imageURL.href; image.alt = ''; image.width = 90; image.height = 90; image.loading = 'lazy'; media.append(image);
        }
        const details = element('div');
        const title = element('a', 'cart-item__title', item.product_title || item.title || 'Product');
        title.href = safeURL(item.url, true)?.href || cartURL; details.append(title);
        if (item.variant_title && item.variant_title !== 'Default Title') details.append(element('div', 'muted cart-item__variant', item.variant_title));
        const quantity = element('div', 'quantity');
        const down = element('button', '', '−');
        down.type = 'button'; down.dataset.qtyDown = ''; down.setAttribute('aria-label', `Decrease quantity of ${item.product_title || 'item'}`);
        const input = element('input');
        input.type = 'text'; input.value = String(item.quantity); input.readOnly = true; input.dataset.qtyInput = ''; input.setAttribute('aria-label', 'Quantity');
        const up = element('button', '', '+');
        up.type = 'button'; up.dataset.qtyUp = ''; up.setAttribute('aria-label', `Increase quantity of ${item.product_title || 'item'}`);
        quantity.append(down, input, up); details.append(quantity);
        const summary = element('div', 'cart-item__price'); summary.append(element('div', 'price', money(item.final_line_price)));
        const remove = element('button', 'cart-item__remove', 'Remove');
        remove.type = 'button'; remove.dataset.remove = ''; remove.setAttribute('aria-label', `Remove ${item.product_title || 'item'}`);
        summary.append(remove); row.append(media, details, summary); fragment.append(row);
      });
      body.replaceChildren(fragment);
      const total = drawer.querySelector('[data-drawer-total]');
      if (total) total.textContent = money(cart.total_price);
      drawer.querySelectorAll('[name="checkout"]').forEach((button) => { button.disabled = !cart.items.length; });
      announceCart('');
      if (focused && activeModal?.panel === drawer) {
        const row = Array.from(body.querySelectorAll('[data-cart-key]')).find((node) => node.dataset.cartKey === focusedKey);
        (row?.querySelector(`[${focusedControl}]`) || body.querySelector('a,button') || drawer.querySelector('[data-close-drawer]'))?.focus({ preventScroll: true });
      }
    }
  };
  window.Cart = Cart;

  function productStatus(form, button, message, error = false) {
    const scope = form || button.parentElement;
    let status = scope.querySelector('[data-bp-product-status], [data-product-status]');
    if (!status) { status = element('p', 'product-form__status'); status.dataset.productStatus = ''; status.setAttribute('aria-live', 'polite'); button.after(status); }
    status.setAttribute('role', error ? 'alert' : 'status'); status.textContent = message;
  }
  async function addToCart(button, event) {
    const form = button.closest('form');
    const idInput = form?.querySelector('[name="id"]');
    const id = idInput?.value || button.dataset.variantId;
    const available = button.dataset.variantAvailable ?? form?.dataset.variantAvailable;
    event.preventDefault();
    if (button.disabled || button.getAttribute('aria-disabled') === 'true' || available === 'false' || button.dataset.cartPending === 'true' || idInput?.disabled || (idInput?.tagName === 'SELECT' && idInput.selectedOptions[0]?.disabled)) return;
    const quantityInput = form?.querySelector('[name="quantity"]');
    const quantity = quantityInput ? Number(quantityInput.value) : 1;
    if (!id || !Number.isInteger(quantity) || quantity < 1 || (quantityInput && !quantityInput.checkValidity())) {
      productStatus(form, button, 'Choose an available option and a valid quantity.', true); return;
    }
    const originalText = button.textContent, originalMinWidth = button.style.minWidth;
    button.style.minWidth = button.getBoundingClientRect().width + 'px'; button.dataset.cartPending = 'true';
    button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = 'Adding…';
    productStatus(form, button, '');
    try {
      await Cart.add(id, quantity);
      productStatus(form, button, 'Added to your basket.');
      (form || button).dispatchEvent(new CustomEvent('bp:cart-added', { bubbles: true, detail: { variantId: String(id), quantity } }));
      openDrawer(button);
    } catch (error) {
      const message = error?.message || 'We could not add this item. Check your basket and try again.';
      productStatus(form, button, message, true);
      (form || button).dispatchEvent(new CustomEvent('bp:cart-error', { bubbles: true, detail: { message } }));
    } finally {
      delete button.dataset.cartPending; button.removeAttribute('aria-busy'); button.style.minWidth = originalMinWidth;
      // The shopper may have changed variants while the request was pending.
      const currentAvailable = button.dataset.variantAvailable ?? form?.dataset.variantAvailable;
      const selectedDisabled = idInput?.tagName === 'SELECT' && idInput.selectedOptions[0]?.disabled;
      const unavailable = currentAvailable === 'false' || selectedDisabled || (idInput && !idInput.value);
      button.disabled = Boolean(unavailable);
      button.textContent = unavailable ? 'Sold out' : button.dataset.addText || originalText;
    }
  }
  let changingDrawer = false;
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const target = event.target, openCart = target.closest('[data-open-cart]');
    if (openCart && drawer && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) { event.preventDefault(); openDrawer(openCart); return; }
    const openNav = target.closest('[data-open-nav]');
    if (openNav && mnav) { event.preventDefault(); openModal(mnav, mnavOverlay, openNav, '[data-open-nav]'); return; }
    if (target.closest('[data-close-drawer], [data-close-nav]') || target === drawerOverlay || target === mnavOverlay) { event.preventDefault(); closeModal(); return; }
    const addButton = target.closest('[data-add-to-cart]');
    if (addButton) { await addToCart(addButton, event); return; }
    const control = target.closest('[data-qty-up], [data-qty-down], [data-remove]');
    const row = control?.closest('[data-cart-key]');
    if (!control || !row || !drawer?.contains(row) || changingDrawer) return;
    event.preventDefault();
    const currentQuantity = Number(row.querySelector('[data-qty-input]')?.value) || 1;
    const nextQuantity = control.hasAttribute('data-remove') ? 0 : Math.max(0, currentQuantity + (control.hasAttribute('data-qty-up') ? 1 : -1));
    changingDrawer = true;
    const body = drawer.querySelector('[data-drawer-items]'); body?.setAttribute('aria-busy', 'true');
    const buttons = Array.from(drawer.querySelectorAll('[data-qty-up], [data-qty-down], [data-remove]'));
    buttons.forEach((button) => { button.disabled = true; });
    try { await Cart.change(row.dataset.cartKey, nextQuantity); }
    catch (error) { announceCart(error?.message || 'We could not change the quantity. Please try again.', true); }
    finally { changingDrawer = false; body?.removeAttribute('aria-busy'); buttons.forEach((button) => { button.disabled = false; }); }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const button = form.querySelector('[data-add-to-cart]');
    if (button && (!event.submitter || event.submitter === button)) addToCart(button, event);
  });

  /* Existing carousel and gallery controls respect reduced motion. */
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-carousel]').forEach((wrap) => {
    const track = wrap.querySelector('[data-carousel-track]');
    if (!track) return;
    [['[data-carousel-prev]', -1], ['[data-carousel-next]', 1]].forEach(([selector, direction]) => {
      wrap.querySelectorAll(selector).forEach((button) => button.addEventListener('click', () => track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: reducedMotion ? 'auto' : 'smooth' })));
    });
  });
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    if (gallery.closest('[data-bp-product]')) return;
    const mainImage = gallery.querySelector('[data-gallery-main-img]');
    gallery.querySelectorAll('[data-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      const source = safeURL(thumb.dataset.full);
      if (mainImage && source) { mainImage.src = source.href; mainImage.removeAttribute('srcset'); }
      gallery.querySelectorAll('[data-thumb]').forEach((node) => { node.classList.toggle('is-active', node === thumb); node.setAttribute('aria-pressed', node === thumb ? 'true' : 'false'); });
    }));
  });

  /* Legacy forms only. The new PDP owns its scoped variant controller. */
  document.querySelectorAll('[data-product-form]:not([data-bp-product-form])').forEach((form) => {
    const data = form.querySelector('[data-variants-json]');
    if (!data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    if (!Array.isArray(variants)) return;
    const idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    const scope = form.closest('.shopify-section') || form.parentElement;
    const price = scope.querySelector('[data-product-price]'), compare = scope.querySelector('[data-product-compare]'), button = form.querySelector('[data-add-to-cart]');
    function update() {
      const options = new Map();
      form.querySelectorAll('[data-option-index]').forEach((input) => { if (input.type !== 'radio' || input.checked) options.set(Number(input.dataset.optionIndex), input.value); });
      const values = Array.from(options).sort(([a], [b]) => a - b).map(([, value]) => value);
      const variant = variants.find((item) => item.options.length === values.length && item.options.every((value, index) => value === values[index]));
      idInput.value = variant ? variant.id : '';
      const available = Boolean(variant?.available); form.dataset.variantAvailable = String(available);
      if (button) {
        button.dataset.variantAvailable = String(available); button.disabled = !available || button.dataset.cartPending === 'true';
        if (button.dataset.cartPending !== 'true') button.textContent = available ? button.dataset.addText || 'Add to basket' : 'Sold out';
      }
      if (!variant) return;
      if (price) { price.textContent = money(variant.price); price.classList.toggle('price--on-sale', variant.compare_at_price > variant.price); }
      if (compare) { compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = compare.hidden ? '' : money(variant.compare_at_price); }
      const source = safeURL(variant.featured_image?.src || variant.featured_media?.src), image = scope.querySelector('[data-gallery-main-img]');
      if (image && source) { image.src = source.href; image.removeAttribute('srcset'); }
    }
    form.addEventListener('change', (event) => { if (event.target.closest('[data-option-index]')) update(); }); update();
  });
  document.querySelectorAll('[data-quantity]').forEach((wrap) => {
    if (wrap.closest('[data-bp-product-form]')) return;
    const input = wrap.querySelector('input');
    if (!input) return;
    [['[data-qty-up]', 1], ['[data-qty-down]', -1]].forEach(([selector, direction]) => wrap.querySelector(selector)?.addEventListener('click', () => {
      const min = Number(input.min) || 1, max = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(max, Math.max(min, (Number(input.value) || min) + direction * (Number(input.step) || 1))));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });

  /* Predictive search uses text nodes, validated URLs and cancellable requests. */
  document.querySelectorAll('[data-predictive-search]').forEach((input, index) => {
    const form = input.closest('form');
    if (!form) return;
    let dropdown = form.querySelector('[data-search-results]');
    if (!dropdown) { dropdown = element('div', 'predictive-results'); dropdown.dataset.searchResults = ''; form.append(dropdown); }
    dropdown.id = dropdown.id || `buyaphone-search-results-${index}`;
    dropdown.setAttribute('role', 'listbox'); dropdown.setAttribute('aria-label', 'Suggested products'); dropdown.hidden = true;
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-controls', dropdown.id); input.setAttribute('aria-expanded', 'false');
    let timer, controller, sequence = 0, selected = -1;
    function close() {
      ++sequence; clearTimeout(timer); controller?.abort(); dropdown.hidden = true;
      input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); selected = -1;
    }
    function select(next) {
      const options = Array.from(dropdown.querySelectorAll('[role="option"]'));
      if (!options.length) return;
      selected = (next + options.length) % options.length;
      options.forEach((option, i) => { option.setAttribute('aria-selected', i === selected ? 'true' : 'false'); option.classList.toggle('is-active', i === selected); });
      input.setAttribute('aria-activedescendant', options[selected].id); options[selected].scrollIntoView({ block: 'nearest' });
    }
    input.addEventListener('input', () => {
      close();
      const query = input.value.trim();
      if (query.length < 2 || query.length > 256) return;
      const requestSequence = sequence;
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const url = new URL(routes.predictive_search_url || root + 'search/suggest', window.location.origin);
          if (url.origin !== window.location.origin) return;
          if (!url.pathname.endsWith('.json')) url.pathname += '.json';
          url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '6');
          const response = await fetch(url.pathname + url.search, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const payload = await response.json();
          if (requestSequence !== sequence || input.value.trim() !== query) return;
          const products = payload.resources?.results?.products;
          if (!Array.isArray(products) || !products.length) return;
          const fragment = document.createDocumentFragment();
          products.forEach((product, productIndex) => {
            const productURL = safeURL(product.url, true);
            if (!productURL) return;
            const option = element('a', 'predictive-item'); option.href = productURL.href; option.id = `${dropdown.id}-option-${productIndex}`;
            option.setAttribute('role', 'option'); option.setAttribute('aria-selected', 'false'); option.tabIndex = -1;
            const imageURL = product.featured_image?.url && safeURL(product.featured_image.url);
            if (imageURL) {
              imageURL.searchParams.set('width', '96');
              const image = element('img'); image.src = imageURL.href; image.alt = ''; image.width = 48; image.height = 48; image.loading = 'lazy'; option.append(image);
            }
            option.append(element('span', 'predictive-item__title', product.title || 'View product')); fragment.append(option);
          });
          if (!fragment.childNodes.length) return;
          dropdown.replaceChildren(fragment); dropdown.hidden = false; input.setAttribute('aria-expanded', 'true');
        } catch (error) { if (error.name !== 'AbortError' && requestSequence === sequence) close(); }
      }, 220);
    });
    input.addEventListener('keydown', (event) => {
      if (dropdown.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); }
      else if (event.key === 'ArrowDown') { event.preventDefault(); select(selected + 1); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); select(selected < 0 ? -1 : selected - 1); }
      else if (event.key === 'Enter' && selected >= 0) {
        const option = dropdown.querySelectorAll('[role="option"]')[selected];
        if (option) { event.preventDefault(); window.location.assign(option.href); }
      } else if (event.key === 'Tab') close();
    });
    document.addEventListener('click', (event) => { if (!form.contains(event.target)) close(); });
    form.addEventListener('submit', close);
  });
  Cart.refresh().catch(() => {});
  window.addEventListener('pageshow', (event) => { if (event.persisted) Cart.refresh().catch(() => {}); });
})();
